/* ================================================== */
/* PROJECTS → range
/* ================================================== */

$(document).ready(function() {

	if ($('body').hasClass('private-view--place')) {
		var $poster = $('.projects-list__item--place .poster'),
			$img    = $('.projects-list__item--place img');

		// Check & apply range cookie
		if (readCookie('octopix_thumb_height') && $poster.length && $img.length) {
			$('.bar .height').val(Number(readCookie('octopix_thumb_height'))).addClass('visible active');

			$poster
				.width(Number(readCookie('octopix_thumb_height')))
				.height(Number(readCookie('octopix_thumb_height')));
		} else {
			$('.bar .height').addClass('visible active');
		}

		// Show thumbs after check
		$('.private-view--place .projects-list--thumbs').addClass('visible');

		// Update range size & cookie on change
		$('.bar .height').on('change mousemove', function() {
			$poster
				.width($(this).val())
				.height($(this).val());

			createCookie('octopix_thumb_height', $(this).val(), '365');

			$(window).scroll();
		});
	}

});